import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISingleTask } from '@qodly/shared';
import { getCachedState } from '~store/utils';

type TTasksState = ISingleTask[];

const tasksSlice = createSlice({
  name: 'Tasks',
  initialState: (): TTasksState => {
    const { tasks } = getCachedState();

    return tasks || [];
  },
  reducers: {
    addTask(state: TTasksState, action: PayloadAction<{ task: ISingleTask }>) {
      const { task } = action.payload;

      state.push(task);
    },
    setError(
      state: TTasksState,
      action: PayloadAction<{ id: string; errorMessage: string }>,
    ) {
      const { id, errorMessage } = action.payload;

      const _state = state.map((ts) => {
        if (ts.id === id) {
          return {
            ...ts,
            payload: {
              ...ts.payload,
              errorMessage: errorMessage,
              status: 'error',
            },
          } as ISingleTask;
        }

        return ts;
      });

      return _state;
    },
    updateTask(state: TTasksState, action: PayloadAction<ISingleTask>) {
      const { id, payload } = action.payload;

      const _state = state.map((t) => {
        if (t.id === id) {
          const _t = {
            ...t,
            payload: {
              ...t.payload,
              ...payload,
            },
          };

          if(_t.payload.status === 'finished'){
            _t.payload.duration = Math.ceil((new Date().valueOf() - new Date(_t.payload.date!).valueOf()) / 1000)
          }

          return _t
        }
        return t;
      });

      return _state;
    },
    clearAllTasks(state: TTasksState) {
      state = state.filter((t) => t.payload.status === 'ongoing');

      return state;
    },
  },
});

export const { addTask, updateTask, clearAllTasks, setError } =
  tasksSlice.actions;

export default tasksSlice;
